import axios, { AxiosResponse } from 'axios'
import {
  ExportaSlotsDto,
  FiltroPlantao,
  Grupo,
  Local,
  Plantao,
  Profissional,
  ProfissionalCompleto,
  ProfissionalSituacao,
  Setor,
  TipoPlantao,
} from './_models'
import { ArquivoDto } from 'app/modules/apps/atendimento/core/_models'

const API_URL = process.env.REACT_APP_API_URL
const PEGA_PLANTAO_URL = `${API_URL}/pegaplantao`
const IMPORTACAO_AGENDA_URL = `${API_URL}/importacao/atendimentos/excel/modelo/preenchido`

/**
 * Lista os plantoes
 * @param data FiltroPlantao
 * @returns Plantao[]
 */
export const getPlantoes = (data: FiltroPlantao): Promise<Plantao[]> => {
  return axios
    .post(`${PEGA_PLANTAO_URL}/plantao`, data)
    .then((resp: AxiosResponse<Plantao[]>) => resp.data)
}

/**
 * Lista os grupos
 * @returns Grupo[]
 */
export const getGruposPlantoes = (): Promise<Grupo[]> => {
  return axios.get(`${PEGA_PLANTAO_URL}/grupo`).then((resp: AxiosResponse<Grupo[]>) => resp.data)
}

/**
 * Lista os locais
 * @returns Local[]
 */
export const getLocaisPlantoes = (query?: string): Promise<Local[]> => {
  return axios
    .get(`${PEGA_PLANTAO_URL}/local${query ? `?${query}` : ''}`)
    .then((resp: AxiosResponse<Local[]>) => resp.data)
}

/**
 * Lista os setores do local
 * @param localId ID do local
 * @returns Setor[]
 */
export const getSetoresByLocal = (localId: string): Promise<Setor[]> => {
  return axios
    .get(`${PEGA_PLANTAO_URL}/local/${localId}/setor`)
    .then((resp: AxiosResponse<Setor[]>) => resp.data)
}

/**
 * Lista os profissionais do setor
 * @param localId ID do local
 * @param setorId ID do setor
 * @returns Profissional[]
 */
export const getProfissionaisByLocalAndSetor = (
  localId: string,
  setorId: string
): Promise<Profissional[]> => {
  return axios
    .get(`${PEGA_PLANTAO_URL}/local/${localId}/setor/${setorId}/profissional`)
    .then((resp: AxiosResponse<Profissional[]>) => resp.data)
}

/**
 * Lista os profissionais
 * @param query string
 * @returns Profissional[]
 */
export const getProfissionaisPlantoes = (query: string): Promise<Profissional[]> => {
  return axios
    .get(`${PEGA_PLANTAO_URL}/profissional?${query}`)
    .then((resp: AxiosResponse<Profissional[]>) => resp.data)
}

/**
 * Detalhes do profissional
 * @param codigo string+
 * @returns ProfissionalCompleto
 */
export const getProfissionalByCodigo = (codigo: string): Promise<ProfissionalCompleto> => {
  return axios
    .get(`${PEGA_PLANTAO_URL}/profissional/${codigo}`)
    .then((resp: AxiosResponse<ProfissionalCompleto>) => resp.data)
}

/**
 * Busca situação dos profissionais no dia
 * @param query string
 * @returns ProfissionalSituacao[]
 */
export const getSituacaoOfProfissionaisByDay = (query: string): Promise<ProfissionalSituacao[]> => {
  return axios
    .get(`${PEGA_PLANTAO_URL}/profissional/situacao?${query}`)
    .then((resp: AxiosResponse<ProfissionalSituacao[]>) => resp.data)
}

/**
 * Lista os tipos de plantão
 * @returns TipoPlantao[]
 */
export const getTiposPlantao = (): Promise<TipoPlantao[]> => {
  return axios
    .get(`${PEGA_PLANTAO_URL}/tipo`)
    .then((resp: AxiosResponse<TipoPlantao[]>) => resp.data)
}

export const downloadAgenda = (data: ExportaSlotsDto): Promise<ArquivoDto> => {
  return axios
    .post(`${IMPORTACAO_AGENDA_URL}`, data)
    .then((resp: AxiosResponse<ArquivoDto>) => resp.data)
}
